import { render, staticRenderFns } from "./GoodSearch.vue?vue&type=template&id=39b87f26&scoped=true&"
import script from "./GoodSearch.vue?vue&type=script&lang=js&"
export * from "./GoodSearch.vue?vue&type=script&lang=js&"
import style0 from "./GoodSearch.vue?vue&type=style&index=0&id=39b87f26&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.9.0@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "39b87f26",
  null
  
)

export default component.exports